import { arrayOf, shape, string } from 'prop-types';

export const headerType = {
  propTypes: shape({
    title: string.isRequired,
    tagline: string,
  }),
  defaultProps: {
    tagline: '',
  },
};

export const headerWithDescType = {
  propTypes: shape({
    title: string.isRequired,
    tagline: string,
    description: string,
  }),
  defaultProps: {
    tagline: '',
    description: '',
  },
};

export const headerWithImageType = {
  propTypes: shape({
    title: string.isRequired,
    tagline: string,
    image: shape({}),
  }),
  defaultProps: {
    tagline: '',
    image: null,
  },
};

export const portableHeaderType = {
  propTypes: shape({
    descripton: arrayOf(shape({})),
  }),
  defaultProps: {
    descripton: [],
  },
};
